import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogTitle } from '@mui/material';
import { CheckCircleOutlined, Close } from '@mui/icons-material';
import Button from '@mui/material/Button';
import { SelectPrimaryPatientRow } from '~/components/dashboard/PatientRow/SelectPrimaryPatientRow';
import { SelectPrimaryPatientMergedRow } from '~/components/dashboard/PatientRow/SelectPrimaryPatientMergedRow';
export const SelectPrimaryPatientModal = (props) => {
    const { onRequestClose, mergedPatients, saveClicked, patient } = props;
    const [primaryPatient, setPrimaryPatient] = useState('');
    const [primaryPatientId, setPrimaryPatientId] = useState('');
    const patientName = patient.personalInfo.firstname + ' ' + patient.personalInfo.lastname;
    const mergeSubmit = () => {
        console.log(mergedPatients);
        if (primaryPatientId === '') {
            alert('Please indicate the primary device.');
        }
        else {
            saveClicked(primaryPatient);
            onRequestClose();
        }
    };
    return (React.createElement(Dialog, { open: true },
        React.createElement(DialogTitle, { sx: { m: 0, p: 2 }, id: "customized-dialog-title" },
            "Primary Device",
            React.createElement("button", { style: { marginLeft: 'auto', float: 'right' }, onClick: onRequestClose },
                React.createElement(Close, null))),
        React.createElement(DialogContent, { dividers: true },
            React.createElement("div", { className: "text-center" }, "Please indicate the primary device."),
            React.createElement("div", { className: "table table-auto border-collapse mt-8 w-full", id: "patients-table" },
                React.createElement(SelectPrimaryPatientRow, { key: patient.id, patient: patient, patientSelected: (patientId) => {
                        setPrimaryPatient(patientId);
                        setPrimaryPatientId(patientId);
                        console.log('selected');
                        console.log(patientId);
                    }, primaryPatientId: primaryPatientId }),
                mergedPatients.map((mPatient) => (React.createElement(SelectPrimaryPatientMergedRow, { key: mPatient.id, patient: mPatient, patientSelected: (patientId) => {
                        setPrimaryPatient(patientId);
                        setPrimaryPatientId(patientId);
                        console.log('selected');
                        console.log(patientId);
                    }, primaryPatientId: primaryPatientId, mergedPatients: mergedPatients, patientName: patientName })))),
            React.createElement("br", null),
            React.createElement("div", { style: { color: '#00000099', marginBottom: '15px' }, className: "text-sm font-medium font-['Barlow'] text-center" }, "*The primary device is the most relevant device for the purposes of a data review. Primary devices must contain CGM data as a part of their displayed data. The primary device is the device that will display data on the patient dashboard, will generate auto-text in the notes section, and will be tracked for patient billing."),
            React.createElement("div", { className: "flex justify-between items-center" },
                React.createElement(Button, { style: { width: '100%' }, variant: "contained", onClick: mergeSubmit, color: "primary", startIcon: React.createElement(CheckCircleOutlined, null) }, "Confirm")))));
};
